import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=4fdb2b7d"
import script from "./CompanyForm.vue?vue&type=script&lang=js"
export * from "./CompanyForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyForm.vue?vue&type=style&index=0&id=4fdb2b7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports